// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* input color class */
::ng-deep input.mat-mdc-input-element {
  color: #111111;
  font-size: 14px;
  caret-color: #484a4c;
}

::ng-deep .mat-mdc-form-field-suffix .mat-mdc-icon-button .mat-mdc-icon {
  font-size: 20px !important;
}

::ng-deep .mat-mdc-form-field.mat-mdc-focused .mat-mdc-form-field-suffix .mat-mdc-icon-button .mat-mdc-icon {
  color: #007566 !important;
}

::ng-deep .mat-mdc-form-field .mat-mdc-form-field-label {
  color: #cccccc !important;
}

/* label color on focused */
.mat-mdc-form-field.mat-mdc-focused .mat-mdc-form-field-label {
  color: #007566 !important;
}

::ng-deep .mat-mdc-mdc-focused .mat-mdc-form-field-underline .mat-mdc-form-field-ripple {
  background-color: #007566 !important;
}

.mat-mdc-form-field.full-width {
  width: 100%;
}

.mdc-text-field--focused > div.mdc-line-ripple.mdc-line-ripple--active {
  background-color: #007566 !important;
}

.mdc-text-field--filled:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-line-ripple::before {
  background-color: #007566 !important;
}

.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom-color: #007566 !important;
}

.mat-mdc-form-field:hover .mat-mdc-form-field-focus-overlay {
  opacity: 0 !important;
}

.mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix {
  padding-top: 0px;
  padding-bottom: 0px;
}

.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mat-mdc-form-field-focus-overlay {
  opacity: 0 !important;
}

input.mat-input-element {
  padding: 20px;
}

.mat-form-field {
  font-size: inherit;
  font-weight: 400;
  line-height: 1.125;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  letter-spacing: normal;
}

.mat-mdc-form-field-icon-suffix .mat-icon-button {
  height: 1.5em !important;
  width: 1.5em !important;
}

div.mat-mdc-text-field-wrapper.mdc-text-field.ng-tns-c3446705053-5.mdc-text-field--filled.mdc-text-field--no-label > div.mat-mdc-form-field-focus-overlay.ng-tns-c3446705053-5.ng-star-inserted {
  opacity: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/main-list/components/mobile/mobile-main-list-search-bar/mobile-main-list-search-bar.component.scss"],"names":[],"mappings":"AAAA,sBAAA;AACA;EACI,cAAA;EACA,eAAA;EACA,oBAAA;AACJ;;AAGA;EACI,0BAAA;AAAJ;;AAIA;EACI,yBAAA;AADJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA,2BAAA;AACA;EACI,yBAAA;AAFJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,uCAAA;AAHJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,wCAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,aAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;EACA,sBAAA;AAVJ;;AAcI;EACI,wBAAA;EACA,uBAAA;AAXR;;AAeA;EACI,qBAAA;AAZJ","sourcesContent":["/* input color class */\n::ng-deep input.mat-mdc-input-element {\n    color: #111111;\n    font-size: 14px;\n    caret-color: #484a4c;\n}\n\n// /* icon size */\n::ng-deep .mat-mdc-form-field-suffix .mat-mdc-icon-button .mat-mdc-icon {\n    font-size: 20px !important;\n}\n\n// /* icon size in focused input */\n::ng-deep .mat-mdc-form-field.mat-mdc-focused .mat-mdc-form-field-suffix .mat-mdc-icon-button .mat-mdc-icon {\n    color: #007566 !important;\n}\n\n// /* label color by default */\n::ng-deep .mat-mdc-form-field .mat-mdc-form-field-label {\n    color: #cccccc !important;\n}\n\n/* label color on focused */\n.mat-mdc-form-field.mat-mdc-focused .mat-mdc-form-field-label {\n    color: #007566 !important;\n}\n\n// /* underline border color on focused */\n::ng-deep .mat-mdc-mdc-focused .mat-mdc-form-field-underline .mat-mdc-form-field-ripple{\n    background-color: #007566 !important;\n}\n\n.mat-mdc-form-field.full-width {\n    width: 100%;\n}\n\n.mdc-text-field--focused > div.mdc-line-ripple.mdc-line-ripple--active {\n    background-color: #007566 !important;\n}\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-line-ripple::before  {\n    background-color: #007566 !important;\n}\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {\n    border-bottom-color:  #007566 !important;\n}\n\n// .mat-mdc-icon-button.mat-mdc-button-base {\n//     padding: 0 0 0 5px !important;\n//     height: unset !important;\n//     width: unset !important;\n//     top: 10px;\n// }\n\n.mat-mdc-form-field:hover .mat-mdc-form-field-focus-overlay {\n    opacity: 0!important;\n}\n\n.mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix {\n    padding-top: 0px;\n    padding-bottom: 0px;\n}\n\n.mat-mdc-form-field-focus-overlay {\n    background-color: transparent!important;\n}\n\n.mat-mdc-form-field-focus-overlay {\n    opacity: 0!important;\n}\n\ninput.mat-input-element {\n    padding: 20px;\n}\n\n.mat-form-field {\n    font-size: inherit;\n    font-weight: 400;\n    line-height: 1.125;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    letter-spacing: normal;\n  }\n\n.mat-mdc-form-field-icon-suffix {\n    .mat-icon-button {\n        height: 1.5em!important;\n        width: 1.5em!important;\n    }\n}\n\ndiv.mat-mdc-text-field-wrapper.mdc-text-field.ng-tns-c3446705053-5.mdc-text-field--filled.mdc-text-field--no-label > div.mat-mdc-form-field-focus-overlay.ng-tns-c3446705053-5.ng-star-inserted {\n    opacity: 0!important;\n}   "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
